import React from "react";
import { Yonela } from "../../assets";

const AdminDetails = () => {
  return (
    <div className="container">
      <div className="flex justify-center gap-[50px] lg-gap-0">
        <div className="w-1/2 hidden md:block">
          <img src={Yonela} alt="" className="" />
        </div>
        <div className="w-full md:w-/2">
          <h2 className="heading">Most asked question by our customers</h2>
        </div>
      </div>
    </div>
  );
};

export default AdminDetails;
